export class Resume {
    constructor(resumeState) {
        this.resumeState = resumeState;
    }
    get questionId() {
        return this.resumeState.questionId;
    }
    get votes() {
        return this.resumeState.votes;
    }
    set votes(v) {
        this.votes = v;
    }
    getState() {
        return this.resumeState;
    }
}
